import { requireAuth } from '@/features/auth/guards/require-auth'
import { projectsListQuery } from '@/features/projects/queries/projects-query'
import { usersListQuery } from '@/features/references/users/users-query'
import { WarehouseEditPage } from '@/features/references/warehouses/pages/warehouse-edit-page'
import { warehouseQuery } from '@/features/references/warehouses/queries/warehouse-query'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'
import * as z from 'zod'

const paramsSchema = z.object({
  warehouseId: z.coerce.number().int().positive(),
})

export const Route = createFileRoute('/_app/references/warehouses/$warehouseId/edit')({
  beforeLoad: requireAuth,
  parseParams: paramsSchema.parse,
  stringifyParams: ({ warehouseId }) => ({ warehouseId: String(warehouseId) }),
  loader: ({ context, params }) => {
    const qc = context.queryClient
    return Promise.all([
      qc.ensureQueryData(warehouseQuery(params.warehouseId)),
      qc.ensureQueryData(projectsListQuery()),
      qc.ensureQueryData(usersListQuery()),
    ])
  },
  component: WarehouseEditRoute,
  staticData: { crumb: messages.crumbs.refWarehouseEdit },
})

function WarehouseEditRoute() {
  const { warehouseId } = Route.useParams()
  return <WarehouseEditPage warehouseId={warehouseId} />
}
